<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos del Cliente</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveCustomer" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--short">
                <label for="first_name" class="form__label form__label--required">Primer Nombre</label>
                <input type="text" class="form__input" name="first_name" id="first_name" placeholder="Primer Nombre" v-model="customer.first_name" v-validate="validation.first_name">
                <span v-show="errors.has('first_name')" class="form__alert">{{ errors.first('first_name') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="middle_name" class="form__label">Segundo Nombre</label>
                <input type="text" class="form__input" name="middle_name" id="middle_name" placeholder="Segundo Nombre" v-model="customer.middle_name" v-validate="validation.middle_name">
                <span v-show="errors.has('middle_name')" class="form__alert">{{ errors.first('middle_name') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="last_name" class="form__label form__label--required">Primer Apellido</label>
                <input type="text" class="form__input" name="last_name" id="last_name" placeholder="Primer Apellido" v-model="customer.last_name" v-validate="validation.last_name">
                <span v-show="errors.has('last_name')" class="form__alert">{{ errors.first('last_name') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="second_last_name" class="form__label">Segundo Apellido</label>
                <input type="text" class="form__input" name="second_last_name" id="second_last_name" placeholder="Segundo Apellido" v-model="customer.second_last_name" v-validate="validation.second_last_name">
                <span v-show="errors.has('second_last_name')" class="form__alert">{{ errors.first('second_last_name') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="phone" class="form__label">Teléfono</label>
                <input type="text" class="form__input" name="phone" id="phone" placeholder="+52 1 (000) 000 00 00" v-model="customer.phone" v-validate="validation.phone">
                <span v-show="errors.has('phone')" class="form__alert">{{ errors.first('phone') }}</span>
              </div>

              <div class="form__container">
                <div class="form__checkbox-container">
                  <input type="checkbox" name="phone_verified" value="1" id="phone_verified" v-model="customer.phone_verified" v-validate="validation.phone_verified">
                  <label for="phone_verified">
                    <span></span> Teléfono Verificado
                  </label>
                </div>
                <span v-show="errors.has('phone_verified')" class="form__alert">{{ errors.first('phone_verified') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="facebook_id" class="form__label">Id de Facebook</label>
                <input type="text" class="form__input" name="facebook_id" id="facebook_id" placeholder="1234567890" v-model="customer.facebook_id" v-validate="validation.facebook_id">
                <span v-show="errors.has('facebook_id')" class="form__alert">{{ errors.first('facebook_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="gender_id" class="form__label">Sexo</label>
                <div class="form__select-container">
                  <select name="gender_id" id="gender_id" class="form__select" v-validate="validation.gender_id" v-model="customer.gender_id">
                    <option :value="null">Seleccionar Sexo</option>
                    <option v-for="(gender, index) in genders" :key="index" :value="gender.id" v-text="gender.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('gender_id')" class="form__alert">{{ errors.first('gender_id') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="dob" class="form__label">Fecha de Nacimiento</label>
                <datepicker :use-utc="true" :language="es" format="dd / MM / yyyy" calendar-class="calendar" input-class="form__input" name="dob" id="dob" v-model="dob" placeholder="31 Dic 1970"></datepicker>
                <span v-show="errors.has('dob')" class="form__alert">{{ errors.first('dob') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="country_id" class="form__label">País</label>
                <div class="form__select-container">
                  <select name="country_id" id="country_id" class="form__select" @change="getStates($event.target.value)" v-validate="validation.country_id" v-model="customer.country_id">
                    <option :value="null">Seleccionar País</option>
                    <option v-for="(country, index) in countries" :key="index" :value="country.id" v-text="country.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('country_id')" class="form__alert">{{ errors.first('country_id') }}</span>
              </div>

              <div class="form__container form__container--short" v-if="states">
                <label for="state_id" class="form__label">Estado</label>
                <div class="form__select-container">
                  <select name="state_id" id="state_id" class="form__select" v-validate="validation.state_id" v-model="customer.state_id">
                    <option :value="null">Seleccionar Estado</option>
                    <option v-for="(state, index) in states" :key="index" :value="state.id" v-text="state.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('state_id')" class="form__alert">{{ errors.first('state_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="city" class="form__label">Ciudad</label>
                <input type="text" class="form__input" name="city" id="city" placeholder="Nombre de la Ciudad" v-model="customer.city" v-validate="validation.city">
                <span v-show="errors.has('city')" class="form__alert">{{ errors.first('city') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="address2" class="form__label">Colonia</label>
                <input type="text" class="form__input" name="address2" id="address2" placeholder="Colonia/Delegación" v-model="customer.address2" v-validate="validation.address2">
                <span v-show="errors.has('address2')" class="form__alert">{{ errors.first('address2') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="address1" class="form__label">Calle y Número</label>
                <input type="text" class="form__input" name="address1" id="address1" placeholder="Calle, número, apt, etc" v-model="customer.address1" v-validate="validation.address1">
                <span v-show="errors.has('address1')" class="form__alert">{{ errors.first('address1') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="zip_code" class="form__label">Código Postal</label>
                <input type="text" class="form__input" name="zip_code" id="zip_code" placeholder="Código Postal" v-model="customer.zip_code" v-validate="validation.zip_code">
                <span v-show="errors.has('zip_code')" class="form__alert">{{ errors.first('zip_code') }}</span>
              </div>

              <h2 class="main__title">Datos de Acceso</h2>

              <div class="form__container form__container--half">
                <label for="email" class="form__label form__label--required">Email</label>
                <input type="email" class="form__input" name="email" id="email" placeholder="Correo Electrónico" v-model="customer.email" v-validate="validation.email">
                <span v-show="errors.has('email')" class="form__alert">{{ errors.first('email') }}</span>
              </div>

              <div class="form__container">
                <div class="form__checkbox-container">
                  <input type="checkbox" name="email_verified" value="1" id="email_verified" v-model="customer.email_verified" v-validate="validation.email_verified">
                  <label for="email_verified">
                    <span></span> Correo Verificado
                  </label>
                </div>
                <span v-show="errors.has('email_verified')" class="form__alert">{{ errors.first('email_verified') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="password" class="form__label" :class="{'form__label--required': $route.name === 'customerNew'}">Contraseña</label>
                <input type="password" class="form__input" name="password" id="password" placeholder="*************" v-model="customer.password" v-validate="validation.password" ref="password">
                <span v-show="errors.has('password')" class="form__alert">{{ errors.first('password') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="confirm_password" class="form__label" :class="{'form__label--required': $route.name === 'customerNew'}">Confirmar Contraseña</label>
                <input type="password" class="form__input" name="confirm_password" id="confirm_password" placeholder="*************" v-model="customer.confirm_password" v-validate="validation.confirm_password">
                <span v-show="errors.has('confirm_password')" class="form__alert">{{ errors.first('confirm_password') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.estatus_id" v-model="customer.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="role_id" class="form__label form__label--required">Rol de Usuario</label>
                <div class="form__select-container">
                  <select name="role_id" id="role_id" class="form__select" v-validate="validation.role_id" v-model="customer.role_id">
                    <option :value="null">Seleccionar Rol</option>
                    <option v-for="(role, index) in roles" :key="index" :value="role.id" v-text="role.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('role_id')" class="form__alert">{{ errors.first('role_id') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">OPCIONES</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'customerList'}">Lista de Clientes</router-link>
        <router-link v-if="$route.name === 'customerEdit'" class="btn btn--small btn__default" :to="{name: 'customerNew'}">Nuevo Cliente</router-link>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, CustomerFields, statusList, texts} from './mocks'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
export default {
  mixins: [httpService],
  components: {
    Datepicker
  },
  data: function () {
    return {
      validation: validation,
      customer: null,
      roles: [],
      statusList: statusList,
      genders: [],
      es: es,
      countries: [],
      states: null,
      mexId: 141
    }
  },
  created: function () {
    this.start()
  },
  watch: {
    '$route.path': function () {
      this.start()
    }
  },
  methods: {
    start: function () {
      this.getRoles()
      this.getGenders()
      this.getCountries()
      if (this.customerId) {
        this.getCustomer()
      }
      if (!this.customerId) {
        this.customer = new CustomerFields()
      }
    },
    getCustomer: function () {
      let httpRequest = {
        params: '',
        module: 'customers'
      }
      this.getById(this.customerId, httpRequest)
        .then(
          customer => {
            this.customer = customer.data
            if (customer.data.country_id == this.mexId) {
              this.getStates(this.mexId)
            }
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'customerNew'})
          }
        )
    },
    getCountries: function () {
      let httpRequest = {
        module: 'countries',
        params: ''
      }
      this.get(httpRequest)
        .then(
          countries => {
            this.countries = countries.data
          }
        )
    },
    getStates: function (id) {
      if (id == this.mexId) {
        let httpRequest = {
          module: 'states',
          params: '?country_id=eq:' + this.mexId
        }
        this.get(httpRequest)
          .then(
            states => {
              this.states = states.data
            }
          )
      } else {
        this.states = null
      }
    },
    getGenders: function () {
      let httpRequest = {
        module: 'genders',
        params: ''
      }
      this.get(httpRequest)
        .then(
          genders => {
            this.genders = genders.data
          }
        )
    },
    getRoles: function () {
      let httpRequest = {
        params: '?id=gte:4',
        module: 'roles'
      }
      this.get(httpRequest)
        .then(
          roles => {
            this.roles = roles.data
          }
        )
    },
    saveCustomer: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                params: '',
                module: 'customers',
                element: this.customer
              }
              let request
              if (this.$route.name === 'customerEdit') {
                request = this.put(this.customerId, httpRequest)
              } else if (this.$route.name === 'customerNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'customerNew') {
                    this.$router.push({name: 'customerEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        )
    }
  },
  computed: {
    customerId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.customer
    },
    texts: function () {
      return texts[this.$route.name]
    },
    dob: {
      get: function () {
        if (this.customer.dob) {
          return this.customer.dob
        }
      },
      set: function (date) {
        this.customer.dob = date
      }
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/customers/edit.vue